export const useApofinderTracking = () => {
  const { GA4_TRACKING_ID, triggerEvent, getContentGroupName } = useGoogleAnalytics()
  const route = useRoute()

  const filterToggleEvent = () => {
    triggerEvent('click', {
      click_item: 'apofinder-filter-toggle',
      send_to: GA4_TRACKING_ID,
      content_group: getContentGroupName(route.name),
    })
  }

  const filterSelectionEvent = (filterName: string) => {
    triggerEvent('click', {
      click_item: 'apofinder-filter-select',
      click_params: filterName,
      send_to: GA4_TRACKING_ID,
      content_group: getContentGroupName(route.name),
    })
  }

  return {
    filterToggleEvent,
    filterSelectionEvent,
  }
}
